import type { TenantDefault } from '../tenant-default/tenant-default.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class TenantDefaultFactory extends ObjectFactory<TenantDefault> {
  protected getDefaults(): TenantDefault {
    return {
      ...baseDocumentFactory.build(),
      defaultHandlingUnitTypeId: null,
    };
  }
}

export const tenantDefaultFactory = new TenantDefaultFactory();
